import React from 'react';
import { connect } from 'react-redux';

import { forcedSidebar } from 'redux/selectors/app';
import { readyCheckDone } from 'redux/selectors/stats';

import {
  Child,
  Design,
  FavoritePicker,
  Giftcard,
  Login,
  MyOrders,
  Notifications,
  Order,
  Profile,
  SaveSuccess,
} from 'components';

import styles from './styles.scss';

let ITEMS = null;

@connect(state => ({
  sidebar: forcedSidebar(state),
  readyCheck: readyCheckDone(state),
}))
export default class Sidebar extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    ITEMS = {
      giftcard: Giftcard,
      myOrders: MyOrders,
      login: Login,
      registration: Login,
      profile: Profile,
      design: Design,
      photos: FavoritePicker,
      child: Child,
      order: Order,
      saveSuccess: SaveSuccess,
    };
  }

  render() {
    const { readyCheck, sidebar } = this.props;
    const SidebarComponent = ITEMS[sidebar];

    return (
      <div className={styles.sidebar}>
        <SidebarComponent sidebar={sidebar} />

        <Notifications showReadyToOrder={readyCheck && ['order', 'myOrders'].indexOf(sidebar) === -1} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/sidebar/index.js